import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { HorizontalRule } from '../HorizontalRule';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
    height: ${theme.tggSpacing(rem(5), '100%')};
`}
`;

export const StyledLinkContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
    display: ${theme.isRebranding('inherit', 'flex')};
    align-items: ${theme.isRebranding('inherit', 'center')};
    padding: ${theme.tggSpacing([0, 0, rem(1.5), rem(3)], [3, 6, 3, 6])};
        `}
`;

type StyledLinkProperties = {
    $caseSensitive: boolean;
};

export const StyledLink = styled('a')<StyledLinkProperties>`
    padding-right: ${({ theme }) => theme.tggSpacing(rem(1), 2.5)};
    color: ${({ theme }) =>
        theme.getRebrandingColor(
            theme.palette.common.blue,
            theme.palette.tgg.text.body.main,
        )};
    text-decoration: none;
    text-transform: ${({ $caseSensitive }) =>
        $caseSensitive ? 'none' : 'lowercase'};

    ${({ theme }: { theme: Theme }) =>
        theme.isRebranding(
            theme.typography.bodySmall,
            theme.typography.bodyStandardRebrand,
        )};

    & :hover {
        text-decoration: underline;
    }
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(29), 81)};
        margin: ${theme.tggSpacing([0, 0, 0, rem(3)], [0, 0, 0, 6])};
        background-color: ${theme.getRebrandingColor(theme.palette.grey['900'], theme.palette.tgg.border.rule.main)};

        ${theme.breakpoints.up(375)} {
            width: ${theme.tggSpacing(rem(34.5), 81)};
        }
    `}
`;
